import React from 'react';
import ListUtils from '../helpers/common/ListUtils';

/**
 * @param {PuzzleCellArgs} param0 
 */
const PuzzleCell = ({cell, puzzleDefinition, coordinates, onClick}) => {

    const onClickWrapper = () => {
        if (onClick && !cell.locked) {
            onClick({
                cell: cell,
                coordinates: coordinates,
            });
        }
    };
    
    return (
        <div 
            className={ListUtils.toHtmlClasses([
                "puzzle-cell",
                cell.selected ? "puzzle-selected" : "",
                cell.locked ? "puzzle-locked" : "",
            ])}
            onClick={onClickWrapper}
            style={{
                height: `${puzzleDefinition.cellHeight}px`,
                width: `${puzzleDefinition.cellWidth}px`,
                backgroundImage: `url('${puzzleDefinition.imageSrc}')`,
                backgroundSize: `${puzzleDefinition.imgWidth}px ${puzzleDefinition.imgHeight}px`,
                // backgroundPositionX: -coordinates.x * puzzleDefinition.cellWidth,
                // backgroundPositionY: -coordinates.y * puzzleDefinition.cellHeight,
                backgroundPositionX: -cell.imgSlice.x * puzzleDefinition.cellWidth,
                backgroundPositionY: -cell.imgSlice.y * puzzleDefinition.cellHeight,
            }}
        >
            
        </div>
    )
};

export default PuzzleCell;
